import { Children, MutableRefObject, ReactNode, useRef } from 'react';

import { UntypedObject } from '@/types';

import styles from './CarouselSlides.module.scss';

type CarouselSlidesProps = {
  children: ReactNode[];
  directionAndStyle: UntypedObject;
  getChildrenRefs: (refs: MutableRefObject<HTMLDivElement>[], index: number) => void;
  withGap: boolean;
  state: UntypedObject;
}
export const CarouselSlides = ({
  children, directionAndStyle, getChildrenRefs, withGap, state
}: CarouselSlidesProps) => {
  const childrenRefs = useRef(Array(Children.count(children)).fill(null));

  const className = [
    withGap ? styles.containerWithGap : styles.containerWithoutGap,
  ].join(' ');

  return (
    <div className={className}>
      {children.map((child, index) => (
        <div
          key={index}
          style={{ ...directionAndStyle, ...state.flexStyle }}
          className={styles.child}
          ref={(element) => {
            childrenRefs.current[index] = element;
            getChildrenRefs(childrenRefs.current[index], index);
          }}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export default CarouselSlides;
